// extracted by mini-css-extract-plugin
export var Heading_label = "slider-module--Heading_label--1254c";
export var arrowContainer = "slider-module--arrow-container--de161";
export var arrowContainerRight = "slider-module--arrow-container-right--a2f86";
export var articles = "slider-module--articles--b88ee";
export var bar = "slider-module--bar--4a3b7";
export var displayNavigation = "slider-module--display-navigation--713ec";
export var featureSubtitle = "slider-module--feature-subtitle--35c50";
export var featuredArticleTitle = "slider-module--featured-article-title--199d9";
export var featuredHeading = "slider-module--featured-heading--68636";
export var grid_section = "slider-module--grid_section--00337";
export var icon = "slider-module--icon--8260e";
export var img_wrapper = "slider-module--img_wrapper--bd46d";
export var mainImg = "slider-module--mainImg--b4ead";
export var nextButton = "slider-module--next-button--fa209";
export var prevButton = "slider-module--prev-button--6488e";
export var product = "slider-module--product--4df1b";
export var productHeading = "slider-module--product-heading--3310e";
export var productSliderTitle = "slider-module--product-slider-title--799ba";
export var productsGrid = "slider-module--products-grid--79285";
export var reccomendedProducts = "slider-module--reccomendedProducts--3afce";
export var sectionProducts = "slider-module--sectionProducts--a0b4d";
export var slickDots = "slider-module--slick-dots--215c1";
export var slickSlider = "slider-module--slick-slider--cd7fb";
export var swiperContainer = "slider-module--swiper-container--1d09a";
export var titleShadow = "slider-module--title-shadow--9e75d";
export var triangle_wrapper = "slider-module--triangle_wrapper--260cd";